<template>
  <transition name="fade">
    <div v-if="value" class="preview-print" @click.self.stop="onClose">
      <div class="py-16 relative">
        <w-button
          class="absolute -translate-x-1/2 left-1/2 top-[68px] z-10"
          @click="onPrint"
        >
          列印專屬條碼
        </w-button>
        <div id="printContent" class="bg-white pb-[62px] pt-[56px] relative">
          <span class="absolute left-12 text-gray-300 text-xs top-4">裁切線</span>
          <div class="absolute left-0 right-0 top-0">
            <div
              v-for="i in cuttingLineLength"
              :key="`cutting-line-row-${i}`"
              class="preview-print__cutting-line"
            >
              <div class="preview-print__cutting-line--block" />
              <div class="preview-print__cutting-line--block" />
              <div class="preview-print__cutting-line--block" />
            </div>
          </div>
          <div class="preview-print__wrapper">
            <div
              v-for="(item, index) in list"
              :key="index"
              class="preview-print__wrapper--block"
            >
              <qrcode-vue
                :value="item.pickup_code"
                :size="86"
                class="mr-4"
                render-as="svg"
                level="H"
              />
              <div class="flex flex-col justify-center">
                <img
                  alt="Logo with text"
                  class="mb-2 w-20"
                  src="@/assets/images/logo-with-text-black.svg"
                />
                <div class="break-all flex flex-col w-[136px]">
                  <span>{{ item.account }}</span>
                  <span>{{ item.member_detail.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import QrcodeVue from 'qrcode.vue';

import Print from '@/utils/printarea';

export default {
  name: 'PrintQrCode',
  components: {
    QrcodeVue,
  },
  props: {
    list: {
      default: () => [],
      type: Array,
    },
    value: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    cuttingLineLength() {
      const l = this.list?.length ? Math.ceil(this.list.length / 2) : 0;
      const QR_PER_PAGE = 8;
      const border = Math.ceil(this.list.length / QR_PER_PAGE);
      return l + border;
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    onPrint() {
      // eslint-disable-next-line no-new
      new Print({
        ids: '#printContent',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active {
  @apply animate-fade-in duration-1000;
  animation-fill-mode: forwards;
}
.fade-leave-active {
  @apply animate-fade-out duration-1000;
  animation-fill-mode: forwards;
}

.preview-print {
  @apply bg-black/40
    flex
    flex-col
    fixed
    h-full
    items-center
    left-0
    overflow-y-auto
    top-0
    w-full
    z-50;

  &__cutting-line {
    @apply flex
      flex-wrap
      h-full
      justify-between
      mb-[192px]
      w-full;

    &:first-child, &:nth-child(5n + 1) {
      > .preview-print__cutting-line--block {
        @apply first:border-l-0 first:border-t-0 h-[56px];

        &:nth-child(2) {
          @apply border-t-0;
        }
        &:nth-child(3) {
          @apply border-t-0 border-r-0 h-[56px];
        }
      }
    }

    &:nth-child(5n) {
      @apply mb-0;
      > .preview-print__cutting-line--block {
        @apply first:border-l-0 first:border-b-0 h-[56px];

        &:nth-child(2) {
          @apply border-b-0;
        }
        &:nth-child(3) {
          @apply border-b-0 border-r-0 h-[56px];
        }
      }
    }

    &--block {
      @apply border-2
      border-gray-300
      border-dotted
      h-[56px]
      w-[40px];

      &:nth-child(1) {
        @apply border-l-0;
      }
      &:nth-child(3) {
        @apply border-r-0;
      }
    }
  }

  &__wrapper {
    @apply bg-white
      gap-x-[40px]
      gap-y-[56px]
      grid
      grid-cols-2
      px-[40px];

      &--block {
        @apply bg-white
          flex
          h-[192px]
          items-center
          px-5
          py-8
          w-full;

        &:nth-child(8n - 1), :nth-child(8n) {
          @apply mb-[56px];
        }
    }
  }
}

@media print {
  * {
    -webkit-print-color-adjust: exact !important;
  }

  .preview-print {
    &__item {
      @apply mb-4 relative rounded;

      page-break-after: always;
      page-break-inside: avoid;
    }
  }
}

@page {
  size: A4 portrait;
  margin: 1cm;
}
</style>
